import React, { useEffect, useState } from 'react';
import { CertMain } from './Certificate.module';
import HelmetHelper from '../../Components/PageHelmet/HelmetHelper.component';
// import { useLocation } from 'react-router-dom';
// import PDFViewer from '../../TrainingRoutes/TakeCourse/PdfViewer.component';
import { useParams } from 'react-router-dom';

const CertificatePage = () => {
  const { token } = useParams();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [certificate, setCertificate] = useState(null);

  useEffect(() => {
    const getCertificate = async () => {
      if (!token) {
        setError('Invalid certificate link.');
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        setError('');

        const API_URL = process.env.REACT_APP_BACKEND_URL || '';

        const res = await fetch(`${API_URL}/users/certs/public/token/${token}`);

        const data = await res.json();

        if (!res.ok) {
          throw new Error(data?.msg || 'This certificate could not be found.');
        }

        setCertificate(data);
      } catch (err) {
        console.error('Certificate lookup failed:', err);

        setError(
          err?.message || 'There was a problem retrieving this certificate.'
        );
      } finally {
        setLoading(false);
      }
    };

    getCertificate();
  }, [token]);

  return (
    <CertMain>
      <HelmetHelper
        title="Company Employee Certificate"
        noIndex
        description="View and download your company employee certificate of completion."
      />
      <div className="cert-grid">
        <section className="cert-main">
          <h1>Certificate of Completion</h1>

          {loading && (
            <div className="loading">
              <div className="spinner" />
              <div style={{ marginLeft: 12 }}>Preparing certificate...</div>
            </div>
          )}

          {!loading && (
            <>
              <p>This certificate is ready to download.</p>

              <div className="iframe-wrap">
                <iframe
                  src={certificate?.certificateUrl || certificate?.downloadUrl}
                  title="Certificate Preview"
                  className="cert-iframe"
                />
              </div>
            </>
          )}

          {error && <p className="cert-error">{error}</p>}
        </section>

        <aside className="cert-side">
          <h3>Need help?</h3>
          <p>
            If the certificate doesn&apos;t display, try opening it in a new tab
            or downloading directly. If you&apos;re still having issues, contact
            us at{' '}
            <a href="mailto:yodasafetyservices1@outlook.com">
              yodasafetyservices1@outlook.com
            </a>
            .
          </p>
        </aside>
      </div>
    </CertMain>
  );
};

export default CertificatePage;
